import axios from 'axios'
import global from '@/global/variable.js'

// 搜索车牌号信息列表
export function getVehicleList(data) {
  const url = global.requestUrl + '/vehicle/list'
  return axios.post(url, data)
}

// 创建加油申请
export function getList(data) {
  const url = global.requestUrl + '/vehicle/apply/getPage'
  return axios.post(url, data)
}

// 创建加油申请
export function createRefuelApply(data) {
  const url = global.requestUrl + '/vehicle/apply/save'
  return axios.post(url, data)
}

// 修改加油申请
export function updateRefuelApply(data) {
  const url = global.requestUrl + '/vehicle/apply/updateById'
  return axios.post(url, data)
}

// 删除加油申请
export function deleteRefuelApply(data) {
  const url = global.requestUrl + '/vehicle/apply/deleteBatch'
  return axios.post(url, data)
}

// 申请跳过人脸识别等验证
export function applySkipCheck(data) {
  const url = global.requestUrl + '/vehicle/apply/applySkipFVVerify'
  return axios.post(url, data)
}

// 审核加油请求
export function checkApply(data) {
  const url = global.requestUrl + "/vehicle/apply/checkApply";
  return axios.post(url, data);
}

// 跳过识别验证
export function checkSkipCheck(data) {
  const url = global.requestUrl + "/vehicle/apply/checkSkipFVVerify";
  return axios.post(url, data);
}

// 获取加油报表
export function getRefuelReport(data) {
  const url = global.requestUrl + "/vehicle/report/refuelReport";
  return axios.post(url, data);
}
// 获取加油记录
export function getRefuelRecord(data) {
  const url = global.requestUrl + "/refuelRecord/getPage";
  return axios.post(url, data);
}